<template>
  <v-row class="ftc" align-content="center" justify="start">
    <v-col>
      <v-dialog
        v-model="dialog"
        persistent
        width="512"
        @click:outside="dialog = false"
      >
        <template #activator="{ props }">
          <v-btn
            color="green"
            size="x-small"
            variant="plain"
            append-icon="mdi-plus"
            v-bind="props"
            >Adicionar Nova Dependência</v-btn
          >
        </template>
        <v-card>
          <v-card-title>
            <div class="d-flex justify-space-between">
              <span class="text-h5">Criar Dependência entre Requisitos</span>
              <v-btn
                variant="plain"
                rounded="xl"
                prepend-icon="mdi-window-close"
                @click="dialog = false"
              ></v-btn>
            </div>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="form" validate-on="lazy submit">
                <v-row>
                  <v-col>
                    <v-select
                      v-model="this.reqSelecionado"
                      label="Requisito*"
                      :items="selectOpcoes.map((item) => item.identificacao)"
                      :rules="reqSelecionadoRules"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>

            <small>*Campo obrigatório</small>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="blue-darken-1"
              variant="text"
              @click="submitDependencia()"
            >
              Salvar
              <v-progress-circular
                v-if="this.isLoading"
                class="ml-2"
                indeterminate
                size="20"
              />
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  emits: ['refetchDepReqs'],
  props: {
    // eslint-disable-next-line no-undef, vue/require-default-prop
    refetch: {
      type: Function,
    },
    dependencias: {
      default: [],
    },
  },

  data: () => ({
    dialog: false,
    reqSelecionado: '',
    eferenteSelecionado: '',
    selectOpcoes: [],
    isLoading: false,
    reqSelecionadoRules: [(v) => !!v || 'Requisito é obrigatório'],
    eferenteSelecionadoRules: [
      (v) => !!v || 'Requisito eferente é obrigatório',
    ],
  }),
  created() {
    const idProjeto = this.$route.params.idProjeto;

    axios
      .get(apiUrl + '/api/v1/requisitos/projeto/' + idProjeto, {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      })
      .then((res) => {
        this.selectOpcoes = res.data.filter((item) =>
          this.constraintSelectFilter(item),
        );
      })
      .catch((error) => console.log(error));
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },
    constraintSelectFilter(item) {
      // Verifica se é o mesmo requisito
      if (item.id_requisito === this.$route.params.id) {
        return false;
      }
      const id =
        item.id_requisito !== this.$route.params.id
          ? item.id_requisito
          : item.id_dependencia_eferente;

      // Verifica se já foi adicionado como dependencia
      const alreadyExist =
        this.dependencias.filter((dep) => {
          if (
            id.toString() === dep.id_requisito &&
            this.$route.params.id.toString() === dep.id_dependencia_eferente
          ) {
            return true;
          }

          if (
            id.toString() === dep.id_dependencia_eferente &&
            this.$route.params.id.toString() === dep.id_requisito
          ) {
            return true;
          }

          return false;
        }).length >= 1;
      if (alreadyExist) {
        return false;
      }

      // Verifica se foi apagado
      if (item.ativo !== true) {
        return false;
      }

      // Verifica se pertence ao projeto
      if (item.id_projeto.toString() !== this.$route.params.idProjeto) {
        return false;
      }
      // console.log(this.$route.params);

      return true;
    },
    async submitDependencia() {
      const isValid = (await this.$refs.form.validate()).valid;
      this.isLoading = true;

      if (isValid) {
        const reqId = this.$route.params.id;
        const eferenteId = this.selectOpcoes.filter(
          (item) => item.identificacao == this.reqSelecionado,
        )[0].id_requisito;

        axios
          .post(
            apiUrl + '/api/v1/requisitos/dependencia',
            {
              // eslint-disable-next-line camelcase
              id_requisito: reqId,
              // eslint-disable-next-line camelcase
              id_dependencia_eferente: eferenteId,
            },
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          )
          .then(() => {
            this.dialog = false;
            this.$emit('refetchDepReqs');
            this.reqSelecionado = '';
            this.selectOpcoes = this.selectOpcoes.filter((item) =>
              this.constraintSelectFilter(item),
            );
          })
          .catch((error) => {
            console.log(error);
            // this.$toast.error(error.response.data.msg);
            this.$toast.error('Erro ao criar dependencia');
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.ftc {
  width: fit-content;
}
</style>
